const MAX_STAIR_HEIGHT = 142;
const MAX_STAIR_WIDTH = 20 * 12;
const MIN_STAIR_WIDTH = 2 * 12;
const MAX_DECK_HEIGHT = 14 * 12;
const MAX_DECK_DEPTH = 16 * 12;
const MAX_DECK_WIDTH = 100 * 12;
const MIN_STAIR_VIABLE_BLOCK_HEIGHT = 15.25;
const MIN_LANDING_WIDTH = 2 * 12;
const MIN_LANDING_DEPTH = 2 * 12;
const MIN_STAIR_HEIGHT = 2 * 12;

export {
	MAX_STAIR_HEIGHT,
	MAX_DECK_HEIGHT,
	MAX_DECK_DEPTH,
	MAX_DECK_WIDTH,
	MAX_STAIR_WIDTH,
	MIN_STAIR_WIDTH,
	MIN_LANDING_WIDTH,
	MIN_LANDING_DEPTH,
	MIN_STAIR_HEIGHT,
	MIN_STAIR_VIABLE_BLOCK_HEIGHT,
};
